var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0}," .st0{fill:#474545;} "),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M242.6,0C108.6,0,0,108.6,0,242.6c0,134,108.6,242.6,242.6,242.6s242.6-108.6,242.6-242.6 C485.2,108.6,376.6,0,242.6,0z M370.7,354l-19.4,19.4c-3.5,3.5-13.6,5.6-13.9,5.6c-61.5,0.5-120.6-23.6-164.1-67.1 c-43.6-43.6-67.8-103-67.1-164.7c0,0,2.2-9.9,5.7-13.3l19.4-19.4c7.1-7.1,20.8-10.4,30.3-7.2l4.1,1.4c9.5,3.2,19.6,13.7,22.2,23.5 l9.8,35.9c2.6,9.7-0.9,23.6-8,30.7l-13,13c12.7,47.1,49.7,84.1,96.9,96.9l13-13c7.1-7.1,21-10.7,30.7-8.1l35.9,9.8 c9.7,2.7,20.3,12.6,23.5,22.2l1.4,4.1C381,333.3,377.8,346.9,370.7,354z"}))]);
}

Phone.defaultProps = {"id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 485.2 485.2","style":{"enableBackground":"new 0 0 485.2 485.2"},"xmlSpace":"preserve"};

module.exports = Phone;

Phone.default = Phone;
